






























































import Vue from 'vue';
import { mapState } from 'vuex';
import userService from '@/services/hub/user';
import AppHeader from '@/components/AppHeader.vue';
import {
  HubHeading,
  HubPagination,
} from '@/components/HubComponents';
import Helpers from '@/utils/Helpers';

export default Vue.extend({
  name: 'WebTV',

  components: {
    AppHeader,
    HubHeading,
    HubPagination,
  },

  props: {
    categoryId: {
      type: String,
      required: true,
    },
    hotsiteId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      availableCategories: [] as Views.ViewHotsites.AvailableCategories[],

      typePlan: '',

      currentPage: 1,

      editLayoutModalIsOpen: false,

      hotsites: { data: [], total: 0 } as Views.ViewHotsites.Hotsites,
      hotsiteTitle: '',
      hotsiteToBeUpdated: {} as Views.ViewHotsites.Hotsite,

      newHotsiteModalOpen: false,
      numberOfHotsitesPerPage: 5,
      numberOfPagesAvailable: 0,
      numberVideosHomepage: '0',

      orderType: 'DESC' as 'ASC' | 'DESC',

      saveButtonLoading: false,
      search: '',
      selectedCategories: [] as number[],
      selectedHotsiteType: '',
      linkToHotsitePage: '',

      tableHeaders: [
        { text: 'name', value: 'name' },
        { text: 'description', value: 'description' },
      ],

      selectedPrimaryColor: '',
      selectedSecondaryColor: '',
      updateHotsiteModalOpen: false,

      timeOutId: 0 as unknown as NodeJS.Timeout,

      filteredPlans: [] as any,
      dataFiltered: [] as any,
      plans: [] as any,
      customerId: [],
      idPlan: '' as number | string,
      categoryItems: [],
    };
  },

  computed: {
    ...mapState(['user']),
    userState(): Store.User.State {
      return this.user;
    },
  },

  watch: {
    search(): void {
      this.currentPage = 1;

      clearTimeout(this.timeOutId);
    },
  },

  mounted() {
    this.getCustomerPlan(this.userState.planId)
      .then((data) => {
        localStorage.setItem('user_id', JSON.stringify({ id_customer: data.id_customers }));
      });
    setTimeout(() => {
      this.getAllCustomerPlans();
    }, 500);
  },

  methods: {
    formatDate(date: string) {
      return Helpers.formatDate((this.userState.settings.lang as Store.User.Language), date);
    },
    getCustomerPlan(planId: number | string): Promise<Services.User.Response.CustomerPlan> {
      return this.$store.dispatch('user/getCustomerPlan', planId)
        .then((response) => {
          this.idPlan = planId;
          // eslint-disable-next-line prefer-destructuring
          this.typePlan = response.name.split('-')[0];
          this.customerId = response.id_customers;
          return response;
        })
        .catch((error) => {
          console.error('Error from getCustomerPlan:', error);
          throw error;
        });
    },
    async getCustomerPlans(data: any) {
      const filter: any[] = await data;
      const plansData = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of filter) {
        // eslint-disable-next-line no-await-in-loop
        const response = await userService.getCustomerPlan(item);
        plansData.push(response);
      }
      this.plans = plansData;
      if (this.plans.length === 1) {
        this.redirectToConfigPage(this.plans[0].data.id);
      }
      // this.loading = false;
    },
    async getCustomerPlansPlayerWebTV(data: any) {
      try {
        const result = await userService.getCustomerPlansPlayerWebTV(data);
        const customerId: any[] = [result.data];
        // eslint-disable-next-line no-restricted-syntax
        await customerId.forEach((plan: any) => {
          if (plan.id_customer_plans !== null) {
            this.dataFiltered.push(plan.id_customer_plans);
          }
        });
        if (this.dataFiltered.length > 0) {
          this.getCustomerPlans(this.dataFiltered);
        }
      } catch (error) {
        console.error(error);
      }
    },
    showNotification(text: string, type: 'error' | 'success'): void {
      this.$store.dispatch('notification/create', { text, type });
    },
    async submitPlansId(id: string) {
      const { categoryId } = this;
      const customerPlansCategoryData = {
        selected_plan_id: id,
      };
      try {
        await userService.createSelectedPlansId(categoryId, customerPlansCategoryData);
        this.showNotification('success_in_save', 'success');
      } catch (error) {
        this.showNotification('error_in_save', 'error');
        console.error('error_in_save:', error);
      }
    },
    async getAllCustomerPlans() {
      try {
        const result = await userService.getAllCustomerPlans(this.customerId);
        const idPlansArray = result.data.data;

        if (Array.isArray(idPlansArray)) {
          this.filteredPlans = idPlansArray;
          this.filteredPlans.forEach(async (plan: any) => {
            await this.getCustomerPlansPlayerWebTV(plan.id);
          });
        } else {
          console.error('idPlansArray is not an array:', idPlansArray);
        }
      } catch (error) {
        console.error(error);
      }
    },
    redirectToConfigPage(newPlanId: any) {
      this.submitPlansId(newPlanId);

      setTimeout(() => {
        this.$router.push(`/Customize/${this.categoryId}/${this.hotsiteId}`);
      }, 400);
    },
  },
});
